// Small helper that turns anything axios might throw into a user-safe string.
// FastAPI returns two shapes for `detail`:
//   • Our HTTPException(detail="...")           → plain string
//   • Pydantic validation errors (HTTP 422)     → array of objects with
//     { type, loc, msg, input, ctx } — NOT renderable by React.
export function formatApiError(err, fallback = 'Something went wrong. Please try again.') {
  const detail = err?.response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail) && detail.length > 0) {
    return detail
      .map((d) => {
        if (typeof d === 'string') return d;
        if (d && typeof d === 'object') {
          const field = Array.isArray(d.loc) ? d.loc.slice(1).join('.') || d.loc.join('.') : '';
          const msg = d.msg || d.message || 'Invalid value';
          return field ? `${field}: ${msg}` : msg;
        }
        return String(d);
      })
      .join(' • ');
  }

  if (detail && typeof detail === 'object') {
    return detail.msg || detail.message || fallback;
  }

  return err?.message || fallback;
}
